import React from 'react'
import { BarLoader } from 'react-spinners'
import styled from 'styled-components'

import '@/components/Payments/shared/payments.css'

const ButtonBase = styled.button`
  width: 100%;
  min-height: 45px;

  &:disabled {
    pointer-events: none;
  }

  &:hover {
    opacity: 0.9;
  }
`

export default function SubmitButton ({
  children,
  className,
  disabled = false,
  loading = false,
  onClick,
  style,
  type = 'button',
  bgColor: _bgColor,
  bsStyle: _bsStyle,
  bsSize: _bsSize,
  block: _block,
  ...rest
}) {
  const isDisabled = disabled || loading

  return (
    <ButtonBase
      {...rest}
      type={type}
      className={['payment-button', className].filter(Boolean).join(' ')}
      disabled={isDisabled}
      onClick={isDisabled ? undefined : onClick}
      style={style}
    >
      {loading ? <BarLoader color='#0d2f05' size={8} /> : children}
    </ButtonBase>
  )
}
